import React, { useEffect, useState } from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { useAuth } from "../contexts/Auth";

interface BannerProps {
  showMenuItems?: boolean;
}

const Banner: React.FC<BannerProps> = ({ showMenuItems = true }) => {
  const { user, refreshAuth } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    refreshAuth();
  }, []);

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  const menuItems = [
    { label: "About", path: "/about" },
    { label: "Pricing", path: "/plans" },
    ...(user
      ? [{ label: "Console", path: "/console" }]
      : [{ label: "Login", path: "/login" }]),
    { label: "Discord", path: "https://discord.gg/7hMTATYZme", external: true },
  ];

  return (
    <AppBar
      position="fixed"
      sx={{
        background: "rgba(0, 74, 173, 0.01)",
        backdropFilter: "blur(8px)",
        boxShadow: "none",
      }}
      elevation={0}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          minHeight: "48px !important",
          py: 0.5,
        }}
      >
        <Link to="/" style={{ textDecoration: "none" }}>
          <img
            src="/es-banner.svg"
            alt="Event Spy"
            style={{
              height: "40px",
              width: "auto",
            }}
          />
        </Link>

        {showMenuItems && (
          <>
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                gap: 3,
                color: "#E3D9D6",
              }}
            >
              {menuItems.map((item, index) =>
                item.external ? (
                  <Button
                    key={index}
                    sx={{
                      color: "#E3D9D6",
                      textTransform: "none",
                      pt: 1,
                    }}
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Typography
                      sx={{
                        fontSize: "1.1rem",
                        fontWeight: "600",
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Button>
                ) : (
                  <Link
                    key={index}
                    to={item.path}
                    style={{ textDecoration: "none" }}
                  >
                    <Button
                      sx={{
                        color: "#E3D9D6",
                        textTransform: "none",
                        pt: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "1.1rem",
                          fontWeight: "600",
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Button>
                  </Link>
                )
              )}
            </Box>
            <IconButton
              sx={{ display: { xs: "block", md: "none" }, color: "#E3D9D6" }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="top"
              open={drawerOpen}
              onClose={toggleDrawer(false)}
              ModalProps={{
                keepMounted: true,
              }}
              sx={{
                "& .MuiDrawer-paper": {
                  position: "absolute",
                  top: "48px",
                  background: "rgba(2, 10, 29, 0.8)",
                  boxShadow: "none",
                  height: "auto",
                  maxHeight: "50vh",
                },
              }}
            >
              <Box
                role="presentation"
                onClick={toggleDrawer(false)}
                onKeyDown={toggleDrawer(false)}
              >
                <List>
                  {menuItems.map((item, index) =>
                    item.external ? (
                      <ListItem
                        key={index}
                        component="a"
                        href={item.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          color: "#E3D9D6",
                          textTransform: "none",
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontSize: "1.1rem !important",
                                fontWeight: "600 !important",
                              }}
                            >
                              {item.label}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ) : (
                      <ListItem
                        key={index}
                        component={Link}
                        to={item.path}
                        sx={{
                          color: "#E3D9D6",
                          textTransform: "none",
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontSize: "1.1rem !important",
                                fontWeight: "600 !important",
                              }}
                            >
                              {item.label}
                            </Typography>
                          }
                        />
                      </ListItem>
                    )
                  )}
                </List>
              </Box>
            </Drawer>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Banner;
